<template>
  <KioskAuthLayout :is-new="false"
                   :next-disabled="$v.name.$invalid"
                   show-next-button
                   show-back-button
                   title="Your name"
                   @back="handleBack"
                   @next="handleNext">
    <div :class="$style.authForm">
      <p :class="$style.authFormText">
        Please enter your first name and last name initial
      </p>

      <div :class="$style.authField">
        <InputField
          :class="[
            $style.authInput,
            { [$style.authInputError]: $v.name.$error }
          ]"
          v-model="$v.name.$model"
          type="text"
        />
        <p v-if="$v.name.$error"
           :class="$style.errorMessage">
          Name is required
        </p>
      </div>

      <div :class="$style.touchKeyboard">
        <Keyboard v-model="$v.name.$model"/>
      </div>
    </div>
  </KioskAuthLayout>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Mutation, Getter, Action } from 'vuex-class';
import { required } from 'vuelidate/lib/validators';
import KioskAuthLayout from '@/layouts/KioskAuthLayout';
import InputField from '@/components/InputField';
import Keyboard from '@/apps/kiosk/components/Keyboard';
import { AUTH_GUEST_INFO, AUTH_LOGOUT, AUTH_PROFILE } from '../../auth/store/types';

/* Provide screen with for customer's name */
@Component({
  components: {
    KioskAuthLayout,
    InputField,
    Keyboard,
  },
  validations: {
    name: { required },
  },
})
export default class KioskAuthForm extends Vue {
  @Getter authUser;
  @Getter isGuest;
  @Mutation(AUTH_GUEST_INFO) setGuestData;
  @Mutation(AUTH_PROFILE) setUserData;
  @Action(AUTH_LOGOUT) authLogout;

  name = '';
  showBackButton = true;
  showNextButton = true;

  processName() {
    const nameParts = this.name.trim().split(' ');
    const lastName = nameParts.length > 1 ? nameParts[1] : 'Client';

    return { firstName: nameParts[0], lastName };
  }

  handleBack() {
    this.authLogout();
    this.$router.go(-1);
  }

  handleNext() {
    const userData = this.processName();

    if (this.isGuest) {
      this.setGuestData(userData);
    } else {
      this.setUserData(userData);
    }

    this.$router.push({ name: 'menu' });
  }

  mounted() {
    if (this.authUser) {
      this.name = `${this.authUser.firstName} ${this.authUser.lastName}`;
    }
  }
}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';

.authForm {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
}

.authFormText {
  font-size: 34px;
  line-height: 48px;
  letter-spacing: 0.19px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 100px;
}

.authField {
  width: 608px;
  margin: 0 auto;
  flex: 1 1 0;
}

.authField .authInput input {
  font-family: "Gotham", sans-serif;
  padding-bottom: 16px;
  font-size: 56px;
  font-weight: 300;
  line-height: 67px;
  letter-spacing: -0.79px;
  height: auto;
  max-height: none;
  text-align: center;
}

.authForm .authField .authInput.authInputError > div > div::before {
  border-color: $red-color;
}

.errorMessage {
  color: $red-color;
  font-size: 24px;
  line-height: 29px;
  font-style: italic;
  text-align: center;
  margin-top: -10px;
}

.touchKeyboard {
  margin: 0 -50px;
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/KioskAuthForm.vue